{
  "dateFormats": {
    "dayNumberShortDay": "{{ date, dayNumberShortDay }}",
    "longMonth": "{{ date, longMonth }}",
    "shortMonthDayYear": "{{ date, shortMonthDayYear }}",
    "time": "{{ date, time }}",
    "dayNumber": "{{ date, dayNumber }}",
    "dayShort": "{{ date, dayShort }}",
    "dayLong": "{{ date, dayLong }}",
    "dateTime": "{{ date, dateTime }}"
  },
  "Now": "Ahora",
  "Today": "Hoy",
  "Yesterday": "Ayer",
  "datePicker": {
    "presets": {
      "yesterday": "Ayer",
      "last7Days": "Últimos 7 días",
      "last14Days": "Últimos 14 días",
      "last30Days": "Últimos 30 días",
      "last90Days": "Últimos 90 días",
      "last6Months": "Últimos 6 meses",
      "last12Months": "Últimos 12 meses"
    }
  },
  "at": "a las",
  "Month": "Mes",
  "Birth date": "Fecha de nacimiento",
  "All day": "Todo el día",
  "Daylight Saving Time ends at {{transitionTime}} on {{dayOfWeek}}, and clocks are set back to {{adjustedTime}}.": "El horario de verano termina a las {{transitionTime}} del {{dayOfWeek}} y los relojes se retrasan a las {{adjustedTime}}.",
  "Daylight Saving Time starts at {{transitionTime}} on {{dayOfWeek}}, and clocks are set forward to {{adjustedTime}}.": "El horario de verano comienza a las {{transitionTime}} del {{dayOfWeek}} y los relojes se adelantan a las {{adjustedTime}}.",
  "Loading events": "Cargando eventos",
  "Events loaded": "Eventos cargados",
  "Scroll left": "Desplazar a la izquierda",
  "Scroll right": "Desplazar a la derecha",
  "moreEvents": "+ {{count}} más",
  "Step {{step}} of {{total}}": "Paso {{step}} de {{total}}",
  "Remove attachment": "Eliminar adjunto",
  "Close modal window": "Cerrar ventana modal",
  "Link image": "Imagen del enlace",
  "New message": "Nuevo mensaje",
  "emptyState": {
    "description": "{{name}} aparecerá aquí cuando esté disponible",
    "descriptionFiltered": "Intenta ajustar tu búsqueda o filtro",
    "title": "No {{name}} todavía",
    "titleFiltered": "No {{name}} encontrado"
  },
  "table": {
    "pagination_one": "{{from}} - {{to}} de {{total}} resultado",
    "pagination_other": "{{from}} - {{to}} de {{total}} resultados"
  }
}
